import "../../CommonImports";
import "../../Core/core.css";
import "./ZeroData.css";
export * from "./ZeroData";
// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export { ZeroDataActionType } from "./ZeroData.Props";
